module.exports = __webpack_public_path__ + "static/media/megaphone.097baf4b.svg";